const { getSsItem, setSsItem } = require('@kznjunk/window-storages')()

export { hasBannerBeenViewed, setBannerAsViewed }

function hasBannerBeenViewed(id) {
    return getSsItem(id) === 'true'
}

function setBannerAsViewed(id) {
    setSsItem(id, 'true')

    return true
}
